// 项目公共配置
let config = {
	fileURL: 'https://car-help.oss-cn-beijing.aliyuncs.com',
	ossConfig: {

	}
}

export default {
	install: function(Vue) {
		Vue.prototype.$config = config
	},
	...config
}



// WEBPACK FOOTER //
// ./src/common/config.js